import React, { useEffect } from 'react';

const MouseTrail = () => {
  useEffect(() => {
    const createTrail = (e) => {
      const trail = document.createElement('div');
      trail.className = 'mouse-trail';
      trail.style.left = e.clientX + 'px';
      trail.style.top = e.clientY + 'px';
      
      document.body.appendChild(trail);

      // Remove trail element after animation
      setTimeout(() => {
        if (document.body.contains(trail)) {
          document.body.removeChild(trail);
        }
      }, 800);
    };

    // Throttle mouse move events for performance
    let lastTime = 0;
    const throttledMouseMove = (e) => {
      const now = Date.now();
      if (now - lastTime > 50) { // Limit to ~20fps for trails
        createTrail(e);
        lastTime = now;
      }
    };

    document.addEventListener('mousemove', throttledMouseMove);

    return () => {
      document.removeEventListener('mousemove', throttledMouseMove);
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default MouseTrail;